var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.879 1.379C-5.96046e-08 2.257 0 3.672 0 6.5V8.5C0 11.328 -5.96046e-08 12.743 0.879 13.621C1.757 14.5 3.172 14.5 6 14.5H12C14.828 14.5 16.243 14.5 17.121 13.621C18 12.743 18 11.328 18 8.5V6.5C18 3.672 18 2.257 17.121 1.379C16.243 0.5 14.828 0.5 12 0.5H6C3.172 0.5 1.757 0.5 0.879 1.379ZM3.555 3.668C3.33434 3.52081 3.06424 3.4673 2.80413 3.51924C2.54402 3.57119 2.3152 3.72434 2.168 3.945C2.02081 4.16566 1.9673 4.43576 2.01924 4.69587C2.07119 4.95598 2.22434 5.1848 2.445 5.332L7.891 8.962C8.21945 9.18085 8.60531 9.29763 9 9.29763C9.39469 9.29763 9.78055 9.18085 10.109 8.962L15.555 5.332C15.7757 5.1848 15.9288 4.95598 15.9808 4.69587C16.0327 4.43576 15.9792 4.16566 15.832 3.945C15.6848 3.72434 15.456 3.57119 15.1959 3.51924C14.9358 3.4673 14.6657 3.52081 14.445 3.668L9 7.298L3.555 3.668Z",
    fill: "#007696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0c769507fa1e7dd0e0fcc9651ecbf888.svg";
export { ForwardRef as ReactComponent };